import { useAppDispatch } from '../../store/hooks/hooks';
import { setReachedTrainings } from '../../store/slice/TrainingsSlice';
import { trainingToTrainingTable } from '../../common/utils/HelperFunction';
import { Trainings } from '../../common/types/types';
import { TrainingComponent } from '../../components/training/TrainingComponent';

export const TrainingContainer = () => {
  const dispatch = useAppDispatch();
  dispatch(setReachedTrainings(trainingToTrainingTable([] as Array<Trainings>)));
  return <TrainingComponent />;
};
